import { parseConfig } from '../../../../shared/config';

const websiteRoot = parseConfig().WEBSITE_ROOT;

export default [
  {
    prefix: 'Commercial Property News',
    region: '',
    uri: `${websiteRoot}/news/`,
  },
  {
    prefix: 'What is equity?',
    region: '',
    uri: `${websiteRoot}/news/equity-guide-small-business-owners/`,
  },
  {
    prefix: 'Commercial Property Investment',
    region: '',
    uri: `${websiteRoot}/news/property-investment-commercial-vs-residential/`,
  },
  {
    prefix: 'FBT Exempt Vehicles',
    region: '',
    uri: `${websiteRoot}/news/fbt-cars-exemptions/`,
  },
  {
    prefix: 'Capitalisation Rate',
    region: '',
    uri: `${websiteRoot}/news/cap-rate-compression-tells-us-market/`,
  },
  {
    prefix: 'Capital Works Deduction',
    region: '',
    uri: `${websiteRoot}/news/tax-building-allowance/`,
  },
  {
    prefix: 'Commercial Property Investment',
    region: '',
    uri: `${websiteRoot}/news/5-mistakes-property-investment/`,
  },
  {
    prefix: 'Sale and Leaseback',
    region: '',
    uri: `${websiteRoot}/news/sale-leaseback-work/`,
  },
];
